<h1 mat-dialog-title>Delete ruleset</h1>
<mat-dialog-content>
  Confirm delete of ruleset?
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>No</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
</mat-dialog-actions>